<div class="attendance-justification-resolution-dialog">
  <h2 mat-dialog-title>{{ data.title }}</h2>

  <mat-dialog-content>
    <p>{{ data.message }}</p>
    <mat-form-field subscriptSizing="dynamic" appearance="outline" class="w-100">
      <mat-label>{{ data.commentLabel }}</mat-label>
      <textarea matInput rows="4" [(ngModel)]="comment" [placeholder]="data.commentPlaceholder || ''"></textarea>
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-stroked-button type="button" class="btn-tone-neutral" (click)="cancel()">
      {{ data.cancelLabel }}
    </button>
    <button mat-flat-button type="button" class="btn-tone-primary" (click)="confirm()" [disabled]="!canConfirm">
      {{ data.confirmLabel }}
    </button>
  </mat-dialog-actions>
</div>
